module.exports = __webpack_public_path__ + "img/weather_locked.c7e20478.svg";